import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {
  public apiEndpoint = environment.apiEndpoint;

  constructor() {}
}
